import { render, staticRenderFns } from "./CombinationReportHome.vue?vue&type=template&id=70ba038e&scoped=true"
import script from "./CombinationReportHome.vue?vue&type=script&lang=js"
export * from "./CombinationReportHome.vue?vue&type=script&lang=js"
import style0 from "./CombinationReportHome.vue?vue&type=style&index=0&id=70ba038e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba038e",
  null
  
)

/* custom blocks */
import block0 from "./CombinationReportHome.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports